import { useCallback, useState } from 'react';

export const useMenu = () => {
  const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);

  const openMenu = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    }, [ setAnchorEl ]);

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
  }, [ setAnchorEl ]);

  return { anchorEl, openMenu, closeMenu };
};

export default useMenu;
